export const topMenu = [
    { name: 'Fale com um Especialista', external: true, class: 'talk-with', url: 'https://lp.vlgicorporate.com.br/fale-com-especialista' }
]

export const sideMenu = [
    { name: 'Home', class: 'home', url: '/'},
    { name: 'Soluções', class: 'vlg-team', url: '/solucoes'},
    { name: 'Quem somos', class: 'about', url: '/quem-somos'},
    { name: 'Unidades', class: 'units', url: '/unidades'},
    { name: 'Contato', external: true, class: 'contact', url: 'https://lp.vlgicorporate.com.br/fale-com-especialista'},
    { name: 'Fale com um Especialista', external: true, class: 'talk-with', url: 'https://lp.vlgicorporate.com.br/fale-com-especialista' }
]
